module.exports = __webpack_public_path__ + "img/4.57e64fdc.png";